import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-need-info',
  templateUrl: './need-info.component.html',
  styleUrls: ['./need-info.component.scss']
})
export class NeedInfoComponent implements OnInit {

  @Input() href: string;
  @Input() mensaje: string;
  @Input() telefono: string;

  constructor() {
    console.log("href", this.href);
  }

  ngOnInit(): void {
  }

  openWhatsApp(e: Event): void {
    e.preventDefault();
    const numero = this.telefono;
    const modifiedNumber = (numero.startsWith('0') ? numero.substring(1) : numero);
    const internationalNumber = '593' + modifiedNumber;
    const esCelular = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const whatsappUrl = esCelular
        ? `https://api.whatsapp.com/send/?phone=${internationalNumber}`
        : `https://web.whatsapp.com/send?phone=${internationalNumber}`;

    window.open(whatsappUrl, '_blank');
  }
}
